import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiActivitiesPageComponent } from './ai-activities-page.component';
import { AiActivitiesModule } from 'src/app/shared/ai-assistant/ai-activities/ai-activities.module';

@NgModule({
  declarations: [AiActivitiesPageComponent],
  imports: [
    CommonModule,
    AiActivitiesModule
  ],
  exports: [AiActivitiesPageComponent],
  entryComponents: [AiActivitiesPageComponent]
})
export class AiActivitiesPageModule { }
